import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Inicio de ${ctx.brand}`,
    languageButtonLabel: `Idioma`,
    languageModalTitle: `Elige un idioma`,
    languageModalCloseLabel: `Cerrar menú de idiomas`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglés`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglés (Kenia)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglés (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglés (Singapur)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugués`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Alemán`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Español`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francés`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Neerlandés`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nórdico & Báltico`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japonés`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarín`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonés`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tailandés`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persa`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Ruso`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Árabe`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Árabe marroquí`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Elige un idioma`,
    closeLabel: `Cerrar menú de idiomas`,
  },
  languageHint: (ctx) => `Cámbiate entre ${ctx.localesCount}+ idiomas en un toque.`,
  readPagePrompt: ({languageLabel}) => `Lee esta página en ${languageLabel}.`,
};
